export const FORM_STEPS = [
  {
    title: 'Заполните анкету, чтобы быстрее найти арендаторов',
  },
  {
    title: 'На каких условиях планируете сдавать',
    description: 'Заполните анкету, чтобы быстрее найти арендаторов',
  },
  {
    title: 'Заявка отправлена',
    description: 'Расскажите подробнее о своей квартире, чтобы мы быстрее нашли арендатора',
    image: true,
  },
];
